import styled, { css, keyframes } from 'styled-components';
import { BLACK, BLACK_300, GREY_2, GREY_4, GREY_6, GREY_7, LIGHT_PRIMARY, PRIMARY } from "../../../utils/colors";
import device from "../../../utils/mediaQuery";

export const Container = styled.section`
  background: #fff;
  padding: 20px;
    
    .ant-modal {
        top: 20px;
    }
`;

export const Wrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 20px 16px 20px;
  background: #fff;
  column-gap: 10px;
  margin-top: 14px;
  
    @media ${device.large} {
      padding: 0;
      background: unset;
      justify-content: center;
    }
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 10px;
`;

export const TopRowLogo = styled.img`
  height: 24px;
  cursor: pointer;
`;

export const SignInButton = styled.button`
  display: flex;
  align-items: center;
  column-gap: 8px;
  background: #fff;
  border: 1px solid ${GREY_7};
  border-radius: 50px;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 600;
  color: ${BLACK};
  font-size: 14px;
  
  &:hover {
    background: ${GREY_2};
  }
`;

export const ProfilePill = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;
  background: ${LIGHT_PRIMARY};
  border-radius: 50px;
  padding: 4px 12px 4px 4px;
  cursor: pointer;
`;

export const ProfileAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const HeaderNameContainer = styled.div`
  border-radius: 100px;
  background: ${GREY_2};
  padding: 8px 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const SearchSummaryPill = styled.div`
  // border-radius: 100px;
  // border: 1px solid ${GREY_4};
  // background: #fff;
  // padding: 6px 6px 6px 16px;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  // flex: 1;
  // margin: 0 10px;

  border-radius: 100px;
  border: 1px solid ${GREY_4};
  background: #fff;
  padding: 6px 6px 6px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  min-width: 0;
  margin: 0 10px;
  overflow: hidden;

  > div:first-child {
    min-width: 0;
    flex: 1;
    overflow: hidden;
  }

  p,
  .ant-typography {
    min-width: 0;
    margin-bottom: 0 !important;
  }

  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media ${device.mobile} {
    margin: 0 8px;
    max-width: calc(100vw - 116px);
  }
`;

export const FilterIconButton = styled.div`
  // border-radius: 50%;
  // border: 1px solid ${GREY_4};
  // background: #fff;
  // width: 40px;
  // height: 40px;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // cursor: pointer;

  // svg {
  //   path {
  //     fill: ${BLACK} !important;
  //   }
  // }

  flex: 0 0 40px;
  border-radius: 50%;
  border: 1px solid ${GREY_4};
  background: #fff;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg {
    path {
      fill: ${BLACK} !important;
    }
  }
`;

export const ProfileBalance = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: ${BLACK};
`;

export const TextContent = styled.div`
  text-align: center;
  flex: 1;
  text-transform: capitalize;
`;

export const DetailsWrapper = styled.div`
  //   display: flex;
  //   column-gap: 10px;
  //   align-items: center;

  //     svg {
  //       path {
  //         fill: ${BLACK_300} !important;
  //       }
  //     }

  // @media ${device.large} {
  //   column-gap: 20px;
  // }

  display: flex;
  column-gap: 5px;
  align-items: center;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;

  .ant-typography {
    white-space: nowrap;
  }

  svg {
    flex-shrink: 0;

    path {
      fill: ${BLACK_300} !important;
    }
  }

  @media ${device.large} {
    column-gap: 20px;
  }
`;

export const EditIconWrapper = styled.div`
  // text-align: right;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // background: ${PRIMARY};
  // border-radius: 50%;
  // width: 32px;
  // height: 32px;
  
  // svg {
  //   cursor: pointer;
  //   width: 16px;
  //   height: 16px;
  //   path {
  //     fill: #fff !important; /* White icon inside orange button */
  //   }
  // }

  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  margin-left: 8px;
  border-radius: 50%;
  background: ${PRIMARY};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: #fff !important;
    }
  }
`;

export const BackIconWrapper = styled.div`
  // cursor: pointer;
  // display: flex;
  // align-items: center;
  // column-gap: 10px;
  
  // svg {
  //   path {
  //     fill: ${BLACK} !important;
  //   }
  // }

  flex: 0 0 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  column-gap: 10px;

  svg {
    path {
      fill: ${BLACK} !important;
    }
  }
`;
export const NavImageIcon = styled.img`
  width: 15px;
  height: 15px;
  padding: 10px;
  box-sizing: content-box;
  background: #fff;
  border-radius: 5px;
  cursor: pointer;
`;

export const FormFieldsWrapper = styled.div`
  .ant-form-item {
    margin-bottom: 12px;
  }
`;

export const DrawerContent = styled.div`
  min-height: 300px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
`;

export const MobileDrawerContent = styled.div`
  //height: calc(100vh - 140px);
  //overflow-y: auto;
`;

export const MobileDrawerContentDisclaimer = styled.div`
  //height: calc(100vh - 140px);
  //overflow-y: auto;
  position: fixed;
  width: 100%;
  padding: 30px 10px;
  bottom: 0px;
  left: 0;
  right: 0;
  background: #fff;
`;


export const SearchContainer = styled.div`
  border: 1px solid ${GREY_7};
  border-radius: 100px;
  padding: 6px 16px;
  width: fit-content;
  max-width: 95%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;


export const SearchItemWrapper = styled.div<{ isModifyBtn?: boolean }>`
    padding: 8px 16px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    column-gap: 8px;
    gap: 18px;
    background: ${GREY_2};
    white-space: nowrap;
    
    ${({ isModifyBtn }) => isModifyBtn && `
       border: none;
       background: ${LIGHT_PRIMARY};
       color: ${PRIMARY};
       
       svg {
        path {
          fill: ${PRIMARY} !important;
        }
      }
    `}
`;



export const SearchWrapper = styled.div`
    display: inline-flex;
    column-gap: 12px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
`;


// ─── B2C STYLES ───────────────────────────────────────────────────────────────

// ─── AIRPORT INPUT ───────────────────────────────────────────────────────────────

export const AirportSearchWrapper = styled.div`
  position: relative;
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI",
    sans-serif;
`;

export const TriggerInput = styled.button<{ $hasValue: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 14px 16px;
  background: #ffffff;
  border: 1.5px solid #e8e8e8;
  border-radius: 100px;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
 
  &:hover {
    border-color: #d0d0d0;
  }
 
  &:focus-visible {
    outline: none;
    border-color: #f0a500;
    box-shadow: 0 0 0 3px rgba(240, 165, 0, 0.12);
  }
 
  ${({ $hasValue }) =>
    $hasValue &&
    css`
      border-color: #e8e8e8;
    `}
`;

export const TriggerIcon = styled.span`
  font-size: 16px;
  color: #888;
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;

export const TriggerText = styled.span<{ $isPlaceholder: boolean }>`
  font-size: 14px;
  font-weight: ${({ $isPlaceholder }) => ($isPlaceholder ? 400 : 500)};
  color: ${({ $isPlaceholder }) => ($isPlaceholder ? "#aaa" : "#1a1a1a")};
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TriggerIata = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #888;
  letter-spacing: 0.5px;
`;

// Popover overlay + panel

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 100;
`;

const fadeSlideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;


export const Popover = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.13), 0 2px 8px rgba(0, 0, 0, 0.06);
  z-index: 101;
  overflow: hidden;
  animation: ${fadeSlideIn} 0.18s ease;
  width: 390px;
`;

export const PopoverHeader = styled.div`
  padding: 20px 20px 0;
`;

export const PopoverTitle = styled.h3`
  margin: 0 0 14px;
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: -0.2px;
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: 2px solid #f0a500;
  border-radius: 14px;
  background: #fff;
  margin-bottom: 4px;
`;

export const SearchIcon = styled.span`
  color: #aaa;
  font-size: 15px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const SearchInput = styled.input`
  border: none;
  outline: none;
  flex: 1;
  font-size: 15px;
  color: #1a1a1a;
  background: transparent;
  font-family: inherit;
 
  &::placeholder {
    color: #bbb;
  }
`;

export const MultiDestinationBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: calc(100% - 40px);
  margin: 12px 20px 0;
  padding: 13px 16px;
  background: #f5f5f5;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #444;
  font-family: inherit;
  transition: background 0.15s ease;
 
  &:hover {
    background: #eeeeee;
  }
 
  svg {
    width: 18px;
    height: 18px;
    color: #666;
  }
`;

export const ResultsList = styled.ul`
  list-style: none;
  margin: 12px 0 0;
  padding: 0 0 8px;
  max-height: 280px;
  overflow-y: auto;
 
  &::-webkit-scrollbar {
    width: 0px;
  }
`;

export const ResultItem = styled.li`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px;
  cursor: pointer;
  transition: background 0.12s ease;
  border-top: 1px solid #f2f2f2;
 
  &:first-child {
    border-top: none;
  }
 
  &:hover {
    background: #fafafa;
  }
 
  &:active {
    background: #f5f5f5;
  }
`;

export const PlaneIcon = styled.span`
  color: #c0c4cc;
  font-size: 18px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;

export const ResultInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ResultCity = styled.p`
  margin: 0 0 2px;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ResultAirport = styled.p`
  margin: 0;
  font-size: 12px;
  color: #999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ResultIata = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: 0.5px;
  flex-shrink: 0;
`;

export const EmptyState = styled.p`
  margin: 0;
  padding: 20px 20px 24px;
  font-size: 14px;
  color: #bbb;
  text-align: center;
`;

// ─── PASSENGER AND CABIN ───────────────────────────────────────────────────────────────

export const PassengerCabinWrapper = styled.div`
  position: relative;
  display: inline-flex;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", sans-serif;
`;

// Trigger pill

export const Pill = styled.button`
  display: flex;
  align-items: center;
  gap: 0;
  padding: 0;
  background: #ffffff;
  border: 1.5px solid #e8e8e8;
  border-radius: 999px;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.18s;
 
  &:focus-visible {
    outline: none;
    border-color: #f0a500;
    box-shadow: 0 0 0 3px rgba(240, 165, 0, 0.12);
  }
 
  &:hover {
    border-color: #d0d0d0;
  }
`;

export const PillSegment = styled.div<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 13px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #2a2a2a;
  border-radius: 0;
  transition: background 0.15s;
  cursor: pointer;
  user-select: none;
 
  ${({ $active }) =>
    $active &&
    css`
      background: #fff8ec;
    `}
 
  &:hover {
    background: ${({ $active }) => ($active ? "#fff3dc" : "#f7f7f7")};
  }
`;

export const Divider = styled.div`
  width: 1px;
  height: 20px;
  background: #e8e8e8;
  align-self: center;
  flex-shrink: 0;
`;

export const PillIcon = styled.span`
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  color: #555;
`;

export const TicketIcon = styled.span`
  font-size: 17px;
  line-height: 1;
  display: flex;
  align-items: center;
  color: #555;
`;

// Popovers

const PopoverBase = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.13), 0 2px 8px rgba(0, 0, 0, 0.06);
  z-index: 101;
  animation: ${fadeSlideIn} 0.18s ease;
  overflow: hidden;
  min-width: 300px;
`;

export const PassengerPopover = styled(PopoverBase)`
  left: 0;
  padding: 24px 12px;
`;

export const CabinPopover = styled(PopoverBase)`
  right: 0;
  padding: 24px 12px;
`;

export const PassengerCabinPopoverTitle = styled.h3`
  margin: 0;
  padding: 20px 20px 16px;
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: -0.2px;
`;

// Passenger rows

export const PassengerRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-top: 1px solid #f2f2f2;
`;

export const PassengerInfo = styled.div`
  flex: 1;
`;

export const PassengerLabel = styled.p`
  margin: 0 0 2px;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const PassengerSublabel = styled.p`
  margin: 0;
  font-size: 12px;
  color: #999;
`;

export const Stepper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const StepBtn = styled.button<{ $disabled?: boolean }>`
  width: 38px;
  height: 38px;
  border-radius: 12px;
  border: none;
  background: #f0f0f5;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 300;
  color: ${({ $disabled }) => ($disabled ? "#ccc" : "#1a1a1a")};
  transition: background 0.15s, color 0.15s;
  flex-shrink: 0;
 
  &:hover:not(:disabled) {
    background: ${({ $disabled }) => ($disabled ? "#f0f0f5" : "#e4e4ec")};
  }
 
  &:active:not(:disabled) {
    background: #d8d8e8;
  }
`;

export const StepCount = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  min-width: 20px;
  text-align: center;
`;

// Cabin rows

export const CabinRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 17px 20px;
  border-top: 1px solid #f2f2f2;
  cursor: pointer;
  transition: background 0.12s;
 
  &:hover {
    background: #fafafa;
  }
 
  &:active {
    background: #f5f5f5;
  }
`;

export const CabinLabel = styled.span`
  font-size: 15px;
  font-weight: 500;
  color: #1a1a1a;
`;

export const RadioCircle = styled.div<{ $selected: boolean }>`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid ${({ $selected }) => ($selected ? "#f0a500" : "#ccc")};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s;
  flex-shrink: 0;
`;

export const RadioDot = styled.div<{ $visible: boolean }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #f0a500;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: scale(${({ $visible }) => ($visible ? 1 : 0.4)});
  transition: opacity 0.15s, transform 0.15s;
`;

// ─── MULTICITY DESTINATIONS ────────────────────────────────────────────────────────


export const MultiCitySearchOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const Backdrop = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(8, 4, 3, 0.18);
`;

export const Panel = styled.div`
  position: relative;
  width: min(1120px, calc(100vw - 40px));
  max-height: calc(100vh - 40px);
  overflow-y: auto;
  padding: 28px 28px 40px;
  border-radius: 34px;
  background: #ffffff;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.12);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 28px;
`;

export const BackButton = styled.button`
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: #2c2c2c;
  font-size: 22px;
  cursor: pointer;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 27px;
  font-weight: 700;
  color: #171717;
`;

export const SelectorRow = styled.div`
  max-width: 460px;
  margin-bottom: 28px;
`;

export const RouteList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 24px;
`;

export const RouteRow = styled.div`
  width: 100%;
`;

export const RouteFields = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px 48px;
  gap: 18px;
  align-items: center;

  @media (max-width: 1080px) {
    grid-template-columns: 1fr;
  }
`;

export const FieldGroup = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 42px minmax(0, 1fr);
  gap: 0;
  align-items: center;
`;

export const FieldSlot = styled.div`
  min-width: 0;
`;

export const SwapButton = styled.button`
  width: 42px;
  height: 42px;
  margin: 0 -10px;
  border-radius: 50%;
  border: 1px solid ${GREY_6};
  background: #f6f6f6;
  color: #7a7a7a;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1;
`;

export const DateField = styled.div`
  min-width: 0;
`;

export const RemoveButton = styled.button`
  width: 44px;
  height: 44px;
  border: none;
  background: transparent;
  color: #434455;
  font-size: 24px;
  cursor: pointer;
`;

export const RemoveSpacer = styled.div`
  width: 44px;
  height: 44px;
`;

export const AddButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-width: 280px;
  height: 62px;
  padding: 0 24px;
  border-radius: 24px;
  border: 1px solid ${GREY_6};
  background: #ffffff;
  color: #161616;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const AddIconCircle = styled.span`
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #1f1f1f;
  font-size: 14px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 18px;
  margin-top: 92px;

  @media (max-width: 760px) {
    flex-wrap: wrap;
  }
`;

export const ActionButton = styled.button`
  min-width: 168px;
  height: 86px;
  border-radius: 28px;
  border: none;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
`;

export const CancelButton = styled(ActionButton)`
  background: #f2f2f2;
  color: #1f1f1f;
`;

export const SearchButton = styled(ActionButton)`
  background: #eca23f;
  color: #ffffff;

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;
